import { styled, SxProps, Theme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type InfoCardProps = {
  sx?: SxProps<Theme>;
  title?: string;
  body?: string;
  link?: any;
};

const InfoCard = ({ sx, title, body, link }: InfoCardProps) => {
  return (
    <Wrapper
      sx={{
        p: { xs: 6, sm: 12 },
        backgroundColor: "#f2f2f2",
        borderColor: ({ palette }) => palette.action.disabled,
        ...sx,
      }}
    >
      <IconContainer>
        <CircularIcon>
          <InfoOutlinedIcon fontSize="large" color="primary" />
        </CircularIcon>
      </IconContainer>
      <InfoBody>
        <br />
        <p style={{ fontWeight: 400, color: "black" }}>{title}</p>
        <br />
        <p style={{ lineHeight: "1.5", color: "#999999" }}>{body}</p>
        <br />
        <a href={link} target="_blank" rel="noopener noreferrer">
          {" "}
          Read More{" "}
        </a>
      </InfoBody>
    </Wrapper>
  );
};

const InfoBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 560px) {
    padding: 12px;
    overflow-y: visible;
  }

  p {
    font-size: 16px;
    font-family: Inter, sans-serif;

    @media (max-width: 560px) {
      font-size: 14px;
    }
  }

  a {
    color: black;
    text-underline-offset: 2px;
    font-size: 16px;
    font-family: Inter, sans-serif;

    @media (max-width: 560px) {
      font-size: 14px;
    }
  }
`;

const CircularIcon = styled("div")`
  background-color: #d1efff;
  padding: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px; /* Adjust the size as needed */
  height: 64px; /* Adjust the size as needed */

  @media (max-width: 560px) {
    width: 48px;
    height: 48px;
    padding: 12px;
  }
`;

const IconContainer = styled("div")`
  padding: 16px;
  position: absolute;
  top: -40px;
  border-radius: 100%;
  background-color: #f2f2f2;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: 560px) {
    top: -30px;
    padding: 12px;
  }
`;

const Wrapper = styled("div")`
  border-radius: 16px;
  width: 400px;
  margin: 0 auto;
  min-height: 400px;
  max-height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  @media (max-width: 560px) {
    width: 100%;
    min-height: 300px;
    border-radius: 12px;
  }

  @media (min-width: 561px) and (max-width: 992px) {
    width: 350px;
    min-height: 350px;
  }

  &.error {
    border-color: ${({ theme }) => theme.palette.error.main};
  }

  p {
    margin: 0;
    color: #3d3d3d;
  }

  button {
    margin-top: 10px;
    padding: 6px 42px;
  }

  &.cropping {
    width: 100%;
    height: auto;
  }
`;

export default InfoCard;
